export function calculate(answers) {
    // Parse inputs
    const s = Number(answers.originalPensionSize) || 0;
    const w = Number(answers.withdrawalPercentage) || 0;
    const wDecimal = w / 100;
    // Gross withdrawal amount
    const a = s * wDecimal;
    // Maximum tax free withdrawal
    const m = Math.min(0.25 * s, 200000);
    // Taxable balance: non-negative
  let t = 0; 
  if (w <= 25 && a <= 200000) {
      t = 0;
  } else if (a <= 200000) {
      t = ((w - 25) / 100) * s;
  } else {
      t = a - 200000;
  }
  // Replace the old single-rate approach with partial bracket logic:
  let paye = 0;
  const taxablePortion = Math.max(0, a - m);
  // Tax the portion from 200k up to 500k at 20%
  if (taxablePortion > 0) {
    const portion20 = Math.min(taxablePortion, 300000);
    paye += portion20 * 0.2;
    // Tax amounts above 500k at 40%
    if (taxablePortion > 300000) {
      const portion40 = taxablePortion - 300000;
      paye += portion40 * 0.4;
    }
  }
  // Total tax is just PAYE
  const totalTax = 0.2*t;
  const netWithdrawal = a - totalTax;
  const netPension = s - a;
  function formatNumber(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2
    }).format(value);
  }
  // Build calculation details as a table with enhanced explanations
  const table = [
    {
      name: 'Original Pension',
      value: `€${formatNumber(s)}`,
      explanation: 'This is the total amount in your pension fund before any withdrawals. It is the basis for all subsequent calculations.'
    },
    {
      name: 'Withdrawal Amount',
      value: `€${formatNumber(a)}`,
      explanation: 'The gross sum withdrawn, calculated as a percentage of your original pension. This is the amount before any taxes are deducted.'
    },
    {
      name: 'Maximum Tax Free Withdrawal',
      value: `€${formatNumber(m)}`,
      explanation: 'The upper limit on tax-free withdrawals, defined as 25% of the original pension or 200,000 euros, whichever is lower.'
    },
    {
      name: 'Taxable Balance',
      value: `€${formatNumber(t)}`,
      explanation: 'This represents the portion of the withdrawal that exceeds the tax-free limit and is therefore subject to taxation.'
    },
    {
      name: 'Marginal Rate PAYE',
      value: `€${formatNumber(paye)}`,
      explanation: 'Calculated tax on the taxable portion using partial bracket logic (20% for amounts up to 500k and 40% thereafter).'
    },
    {
      name: 'Total Tax Liability',
      value: `€${formatNumber(totalTax)}`,
      explanation: 'The total tax due on the withdrawal, which directly reduces the amount you receive in hand.'
    },
    {
      name: 'Net Withdrawal',
      value: `€${formatNumber(netWithdrawal)}`,
      explanation: 'The actual amount deposited in your bank account after deducting total tax from the gross withdrawal.'
    },
    {
      name: 'Remaining Pension',
      value: `€${formatNumber(netPension)}`,
      explanation: 'The balance left in your pension fund after the withdrawal, indicating the long-term impact on your retirement savings.'
    }
  ];
  
  const items = [];
  items.push(" ");
  // Prepare result object
  return {
    title: "Total Withdrawal Amount",
    status: `€${formatNumber(netWithdrawal)}`,
    message: `Based on a pension of €${formatNumber(s)} with a withdrawal of ${w}%`,
    items,
    table
  }
}